// extracted by mini-css-extract-plugin
module.exports = {"container":"Message_container_3911b","show":"Message_show_2ULuq"};